// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class StarFill extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>Favorito</title>
        <desc>Representação de uma estrela amarela</desc>
        <g id="icon-star-fill">
          <path d="M8,0A1.14,1.14,0,0,0,7,.6L5.17,5.27,1,5.78a1.15,1.15,0,0,0-.61,2l3.05,2.44L2.31,14.65A1.14,1.14,0,0,0,3.43,16a1.18,1.18,0,0,0,.5-.12L8,13.27l4.07,2.61a1.18,1.18,0,0,0,.5.12,1.14,1.14,0,0,0,1.12-1.35l-1.12-4.44,3-2.44a1.15,1.15,0,0,0-.61-2l-4.18-.51L9,.6A1.14,1.14,0,0,0,8,0Z" />
        </g>
      </svg>
    );
  }
}

export default StarFill;
